import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Layout } from "antd";
import { Loading } from "../Common/components/Loading";
import styles from "./styles/BugListingAdmin.module.css";
import { bugReportHandle } from "./state/actions";
import { BUGTable } from "./components/BUGTable";
import { Redirect } from "react-router-dom";
import { roleAccessFunc } from "../Common/commondata/commonData";
import TicketTable from "./components/TicketTable";
// import { NDATable } from "./components/NDATable";
const { Content } = Layout;

function BugReportAdmin() {
  const dispatch = useDispatch();
  const { logInData, bugPostData, bugLlistingData, bugLlistLoading, bugReportCommentData } = useSelector((state) => state.bugReport);
  const { adminRole, roleAccessed } = useSelector((state) => state.account, shallowEqual);
  if (!roleAccessFunc(roleAccessed, "BUGS")) {
    return <Redirect to="/error" />;
  }
  return (
    <Layout>
      <Content>
        <TicketTable list={bugLlistingData} />
      </Content>
    </Layout>
  );
}

export { BugReportAdmin };
